// Adapted from Dynamix's LedFace and harsh136/interactive-face-animation (MIT).
// Attribution and license: public/licenses/interactive-face-animation.txt
import React, { useEffect, useRef } from 'react';
import '../../styles/dynamicsRobot.css';

export default function DynamicsIcon({ size = 24, state = 'idle', className = '', ...props }) {
  const face = useRef(null);
  useEffect(() => {
    const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (motion?.matches || size < 28) return;
    const follow = event => {
      const element = face.current;
      if (!element || document.hidden) return;
      const rect = element.getBoundingClientRect();
      const x = event.clientX - rect.left - rect.width / 2;
      const y = event.clientY - rect.top - rect.height / 2;
      const angle = Math.atan2(y, x);
      element.style.setProperty('--look-x', `${Math.cos(angle) * 4}%`);
      element.style.setProperty('--look-y', `${Math.sin(angle) * 5}%`);
    };
    const reset = () => {
      face.current?.style.setProperty('--look-x', '0%');
      face.current?.style.setProperty('--look-y', '0%');
    };
    window.addEventListener('pointermove', follow);
    window.addEventListener('blur', reset);
    return () => { window.removeEventListener('pointermove', follow); window.removeEventListener('blur', reset); };
  }, [size]);
  return <span ref={face} aria-hidden="true" {...props} className={`dynamics-robot ${className}`} data-state={state} style={{width:size,height:size}}>
    <span className="dynamics-robot-eye dynamics-robot-left" />
    <span className="dynamics-robot-eye dynamics-robot-right" />
  </span>;
}
